module.exports = __webpack_public_path__ + "img/20190611_113036_002.b978f46d.jpg";